import React, { Component } from 'react';
import { Link } from 'react-router-dom'

import Element from '../services/Element.js'
import MobileIdentifier from '../services/MobileIdentifier.js'

import '../../css/TagList.css';

class TagList extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      expanded: props.expanded || false,
      selector: props.selector || false
    }
    window.addEventListener("resize", this.refresh.bind(this));
  }

  refresh() {
    this.setState({});
  }

  render() {

    let isMobile = MobileIdentifier();

    let mobile = isMobile ? 'mobile' : '';

    let tags = this.props.tags.slice(0,20).map((tag) => {
      return (
        <li key={tag}>
          <Link className={`clickable`} to={Element.url('tag', {tag})}>#{tag}</Link>
        </li>
      );
    });

    let expanded = this.state.expanded ? 'expanded' : '';
    let selector = mobile && this.state.selector ? 'selector' : '';

    return (
      <ul className={`tags ${expanded} ${mobile} ${selector}`}>
        {tags}
      </ul>
    );
  }

}

export default TagList;



// WEBPACK FOOTER //
// ./src/js/components/TagList.jsx